/**
 * Smooth accordion animation for <details> elements
 * within the collapsible-content section.
 */
(function () {
  const DURATION = 300;
  const EASING = 'ease';

  class Accordion {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector('summary');
      this.content = details.querySelector('.accordion__content');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      if (!this.summary || !this.content) return;

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();

      // Don't allow rapid double-clicks to break state
      this.details.style.overflow = 'hidden';

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.close();
      }
    }

    close() {
      this.isClosing = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply fixed height before open so we can animate from it
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;

      // Wait for the browser to apply `open` and lay out content
      requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING }
      );

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = '';
      this.details.style.overflow = '';
    }
  }

  function init() {
    document
      .querySelectorAll('.collapsible-content .accordion details')
      .forEach((details) => new Accordion(details));
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify section is loaded/re-rendered in the theme editor
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();